<template>
  <router-view/>
</template>

<style scoped>

</style>
